export default function Header({ isMobile, children }) {
  return (
    <div className={"header" + (isMobile ? "-mobile" : "")}>{children}</div>
  );
}
